// Redux-Form names

export const PARTNER_VAST_FORM = "partner-vast";
export const YOUTUBE_URL_FORM = "youtube-url-vast";
